<template>
  <div class="home">
    <section
      class="main product__management"
    >
      <PersonnelPlanningNew />
    </section>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PersonnelPlanningNew from '../components/PersonnelPlanningNew.vue'

export default {
  name: 'Home',
  components: {
    PersonnelPlanningNew,
  },
  data() {
    return {
      filialeIdShow: '',
      routeIdShow: '',
      truckShow: {},
      time2: null,
    };
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    ...mapActions([]),
  },
};
</script>

  <style lang="scss" scoped>
  .product__management .hide-on-products {
    display: none;
  }

  .main{
    display: block;
    padding: 90px 15px 15px 110px;
  }

  @media screen and (max-width: 1200px){
    .main{
      padding: 90px 15px 15px 90px;
    }
  }

  @media screen and (max-width: 1041px) {
    .main {
      padding: 80px 0.75rem 0 0.75rem;
    }
  }
  @media screen and (max-width: 896px) {
    .main {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }
  </style>
